
// TODO: Add unit tests for these, or at least the more complicated ones

// Validators shouldn't fail if nothing is inputted -- only required should
// -- but this will correct the behavior for optional fields
export const optionalValidate = validator => value =>
  typeof value === 'string' && value !== '' ? validator(value) : undefined

/**
 * A field validation that the field's value must exist
 * 
 * @param {*} value 
 */
export const required = value => value != null && value !== '' ? undefined : 'Required'

/**
 * This function must be curried first before use
 * @example const lengthExactly15 = lengthExactly(15)
 * @param {Number} length
 */
export const lengthExactly = length => value => value && value.length !== length ? `Must be ${length} characters ` : undefined

/**
 * This function must be curried first before use
 * @example const maxLength15 = maxLength(15)
 * @param {Number} max
 */
export const maxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined

/**
 * This function must be curried first before use
 * @example const minLength15 = minLength(15)
 * @param {Number} min
 */
export const minLength = min => value => value && value.length < min ? `Must be ${min} characters or more` : undefined

export const maxLength2000 = maxLength(2000)

export const maxLength4000 = maxLength(4000) // At the very least, validate that the value can fit in an ordinary Oracle database column

export const phoneNumber = value => value && !/([0-9]{10})/.test(value ? value.replace(/(\D)(\s)*/g, '') : '') ? 'Phone number must be 10 digits' : undefined

export const numeric = value => value && /[^0-9]+/i.test(value) ? 'Only numeric characters are allowed' : undefined

export const realNumber = value => Number.isFinite(Number(value)) ? undefined : 'Value does not denote a real number'

export const alphaNumeric = value => value && /[^a-zA-Z0-9 ]/i.test(value) ? 'Only alphanumeric characters are allowed' : undefined

export const startsWithALetter = value => value && value.length > 0 && /^\d/i.test(value) ? 'Must start with a letter' : undefined

/**
 * This function must be curried first before use
 * @example const minValue15 = minValue(15)
 * @param {Number} min
 * 
 */
export const minValue = min => value => value && value < min ? `Must be at least ${min}` : undefined

/**
 * This function must be curried first before use
 * @example const maxValue15 = maxValue(15)
 * @param {Number} max 
 * 
 */
export const maxValue = max => value => value && value > max ? `Must be no more than ${max}` : undefined

export const positive = value => value > 0 ? undefined : 'Value must be greater than zero'

export const nonNegative = value => value >= 0 ? undefined : 'Value must not be less than zero'

export const integer = value => Number.isInteger(value) ? undefined : 'Must be an integer e.g. -1, 0, 1, or 7'

export const wholeNumber = value => Number.isInteger(value) && value >= 0 ? undefined : 'Must be a whole number e.g. 0, 1, or 7'

export const naturalNumber = value => Number.isInteger(value) && value > 0 ? undefined : 'Must be a natural number e.g. 1 or 7'

/* 
  Re-usable validations for common fields across the application where it makes more sense than manual composition. 
  Ideally expressed as a composition of other validations.
  These may gain more complex validations as time goes on but at the very least they should not allow a value greater than our data size
 */
const maxLength64 = maxLength(64)
const lengthExactly9 = lengthExactly(9)
export const ssn = value => numeric(value) || lengthExactly9(value)
export const name = value => maxLength64(value)
export const fullName = value => value && !value.includes(' ') ? 'Please enter your full name' : undefined
export const username = value => maxLength64(value)
export const isValidLin = value => !(/(\d{2}-)+?(\d{2}-)+?(\d{1}-)+?(\d{7})+?/.test(value))
//TODO: apostrophes and single quotes are allowed in emails but this does not allow them
export const email = value => maxLength64(value) || (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? 'Invalid email address' : undefined)

export const namedMinLength = (name, length) => value => value && value.length < length ? `${name} must be at least ${length} characters` : undefined

export const namedValueBetween = (name, min, max) => value => value && (value < min || value > max) ? `${name} must be between ${min} and ${max}` : undefined

export const namedNonNegative = (name) => value => value >= 0 ? undefined : `${name} cannot be less than zero`

export const namedPositive = (name) => value => value > 0 ? undefined : `${name} must be greater than zero`

export const validateZip = (zip) => zip && (zip < '00501' || zip > '99950') ? 'Invalid Zip' : undefined

export const validateDate = str => (Number.isNaN(new Date(str).getTime()) ? 'Invalid Date' : undefined)

export const dateMinLength = (length) => value => value && value.length < length ? `Date format must be: mm/dd/yyyy` : undefined

/**
 * This function validates that cron schedules are of length 5 or 6 and that MANUAL is acceptable. 
 * @param {String} cron
 */
export const validateCron = (cron) => !((cron.trim().split(" ").length === 5) || (cron.trim().split(" ").length === 6)) && !(cron.trim().toUpperCase() === 'MANUAL') ? `Invalid Cron Schedule Length: ${cron.split(" ").length}` : undefined

/**
 * This function validates that multiple emails are valid. 
 * @param {String} emails
 */
export const validateMultipleEmails = (emails) => {
  var regex = /^(\w+(\.?|-?))+\w+@\w+\.\w+$/;
  var result = emails.replace(/\s/g, "").split(/,|;/);        
  for(var i = 0;i < result.length;i++) {
      if(!regex.test(result[i])) {
          return 'Invalid email address';
      }
  }       
}

/**
 * This function must be curried first before use
 * @example const maxApplicationDate = namedMaxDate('Application Date', Date())
 *
 * @param {Date} date
 */

export const namedMaxDate = (name, date) => str => (new Date(str) > date ? `${name} must not be a future date` : undefined)



//TODO: replace with single exports, to import them all use import * as validations
// Do not add more member functions here
const validations = {
  required: value => value != null ? undefined : 'Required',
  requiredDropdown: value => value === '- Select -' || value === '' || value === null ? 'Required' : undefined,
  maxLength: max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined,
  email: value => value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? 'Invalid email address' : undefined,
  minValue: min => value => value && value.length < min ? `Must be at least ${min}` : undefined,
  minLength4: value => value && value.length < 4 ? `Minimum length must be 4` : undefined,
  minLength5: value => value && value.length < 5 ? `Minimum length must be 5` : undefined,
  minLength6: value => value && value.length < 6 ? `Minimum length must be 6` : undefined,
  minLength7: value => value && value.length < 7 ? `Minimum length must be 7` : undefined,
  minLength9: value => value && value.length < 9 ? `Minimum length must be 9` : undefined,
  minLength10: value => value && value.length < 10 ? `Minimum length must be 10` : undefined,
  alphaNumeric: value => value && /[^a-zA-Z0-9 ]/i.test(value) ? 'Only alphanumeric characters are allowed' : undefined,
  numeric: value => value && /[^0-9 ]/i.test(value) ? 'Only numeric characters are allowed' : undefined,
  phoneNumber: value => value && !/([0-9]{10})/.test(value ? value.replace(/(\D)(\s)*/g, '') : '') ? 'Phone number must be 10 digits' : undefined
}

export default validations